import { render, staticRenderFns } from "./urlComponent.vue?vue&type=template&id=083e75e8&scoped=true&"
import script from "./urlComponent.vue?vue&type=script&lang=ts&"
export * from "./urlComponent.vue?vue&type=script&lang=ts&"
import style0 from "./urlComponent.vue?vue&type=style&index=0&id=083e75e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083e75e8",
  null
  
)

export default component.exports